// getCroppedImg.js
const createImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.crossOrigin = "anonymous";
    img.src = src;
  });

export default async function getCroppedImg(imageSrc, croppedAreaPixels) {
  const image = await createImage(imageSrc);

  const cropX = Math.max(0, Math.floor(croppedAreaPixels.x));
  const cropY = Math.max(0, Math.floor(croppedAreaPixels.y));
  const cropWidth = Math.min(
    Math.floor(croppedAreaPixels.width),
    image.naturalWidth - cropX
  );
  const cropHeight = Math.min(
    Math.floor(croppedAreaPixels.height),
    image.naturalHeight - cropY
  );

  if (cropWidth <= 0 || cropHeight <= 0) {
    throw new Error("Invalid crop area");
  }

  // Create a <canvas> matching the crop region size
  const canvas = document.createElement("canvas");
  canvas.width = cropWidth;
  canvas.height = cropHeight;
  const ctx = canvas.getContext("2d");

  // Fill background so transparent images don't appear black in viewers
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, cropWidth, cropHeight);

  // Draw that exact slice from the original image
  ctx.drawImage(
    image,
    cropX,
    cropY,
    cropWidth,
    cropHeight,
    0,
    0,
    cropWidth,
    cropHeight
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("Canvas is empty"));
        return;
      }
      resolve(blob);
    }, "image/png", 1);
  });
}
